<template>
  <div
    :id="`footnote-target-${targetId}`"
    class="footnote-target-wrapper"
    tabindex="-1"
  >
    <a
      v-smooth-scroll
      :href="`#footnote-reference-${targetId}`"
      class="footnote-anchor"
      @click.prevent="setFocus"
    >
      <span class="a-visually-hidden">
        <a-label path="footnote.to-reference" :is-visible="true"></a-label
        >&nbsp; </span
      >[{{ targetId }}]</a
    >
    <div class="footnote-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    targetId: {
      type: String,
      required: true,
    },
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        document.querySelector(`#footnote-reference-${this.targetId}`).focus();
      });
    },
  },
};
</script>
